import { LinearProgress, withStyles } from "@material-ui/core";

const stylesCustomLinearProgress = {
  root: {
    height: 6,
    borderRadius: 8,
    backgroundColor: "#E7F3FF",
    width: 233,
    margin: "0 auto",
  },
  bar: {
    borderRadius: 8,
    backgroundColor: "#0A76DC",
  },
};

export const CustomLinearProgress = withStyles(stylesCustomLinearProgress)(
  LinearProgress,
);

export const translations = {
  title: {
    id: "vehicle.single.registry.upload.uploadFile.title",
    defaultMessage: "Upload your file",
  },
  subtitle: {
    id: "vehicle.single.registry.upload.uploadFile.subtitle",
    defaultMessage:
      "You can also download a blank template or one pre-filled with vehicles already registered in GoHub.",
  },
  draggerTitle: {
    id: "vehicle.single.registry.upload.uploadFile.dragger.title",
    defaultMessage: "Click to select a file or drag and drop it here.",
  },
  acceptedFiles: {
    id: "vehicle.single.registry.upload.uploadFile.dragger.acceptedFiles",
    defaultMessage: "Accepted files (.xls or .xlsx)",
  },
  replaceFile: {
    id: "vehicle.single.registry.upload.uploadFile.action.replaceFile",
    defaultMessage: "Replace file",
  },
  importFile: {
    id: "vehicle.single.registry.upload.uploadFile.action.import",
    defaultMessage: "Import",
  },
  downloadTemplate: {
    id: "vehicle.single.registry.upload.uploadFile.action.downloadTemplate",
    defaultMessage: "Download template",
  },
};

export const acceptedExtensionsExt = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];
